// extracted by css-extract-rspack-plugin
export default {"breadcrumbsWrapper":"JWUJt","breadcrumbLastLabel":"YAfrI","breadcrumbLinkLabel":"UqEr5"};